import React, { useEffect, useRef,useState } from 'react';
import pictoGeoloc from "../assets/images/picto-geolocalisation.svg";
import AutocompleteVille from "../assets/components/AutocompleteVille";
import Axios from 'axios';
import {urlAPIDirectus} from "../Map/config/globals";

function useSearchCommune(query) {

    const [isLoadingCommune, setIsLoadingCommune] = useState(false);
    const [dataCommune, setDataCommune] = useState([]);
    useEffect(() => {
        if (!query){
            setDataCommune([]);
            return;
        }
        setIsLoadingCommune(true);
        const timeOutId = setTimeout(() => fetchData(query), 500);
        return () => clearTimeout(timeOutId);
    }, [query]);

    function fetchData() {
        setDataCommune([]);
        let cancel;
        Axios({
            method: "GET",
            url: urlAPIDirectus + "commune?fields=id,nom,geom,insee_dep,insee_com&filter[insee_dep][_in]=83,13,84,04,05,06,34,26&filter[nom][_istarts_with]="+query,
            cancelToken: new Axios.CancelToken((c) => (cancel = c)),
            headers: {
                'Content-type' : 'application/json'
            }
        })
        .then((res) => {
            setIsLoadingCommune(false);
            setDataCommune(res.data.data);
        })
        .catch((e) => {
            if (Axios.isCancel(e)) return;
        });
        return () => cancel();
    }
    return { dataCommune, isLoadingCommune };
}

export const Search = ({selectCommune, listHide, setListHide}) => {
    const [queryCommune, setQueryCommune] = useState("");
    const { dataCommune, isLoadingCommune } = useSearchCommune(queryCommune);
    function handleSearchCommune(e) {
        const { value } = e.target;
        setQueryCommune(value);
        setListHide(false);
    }
    return(
        <>
        <div className="d-none d-lg-flex col-6 col-xxl-4 border-end border-2 justify-content-start">
            <span className="d-lg-none">Inventaire</span>
            <AutocompleteVille listHide={listHide} handleSearch={handleSearchCommune} data={dataCommune} isLoading={isLoadingCommune} selectItem={selectCommune} />
            <a href="#!" className="btn btn-primary rounded-circle ratio-11 me-5">
                <img className="" src={pictoGeoloc} alt="Géolocalisation"/>
            </a>
        </div>
        </>
    );
};
